module.exports = __webpack_public_path__ + "img/happybrain_product2.f18e9715.jpg";